<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">

      <el-card class="box-card">
        <div class="title mt20">发票信息</div>
        <div>
          <li v-if="invoicetype == 0">未选择开发票</li>
          <li v-if="invoicetype == 1">个人发票抬头：{{invoice1Name}}</li>
          <li v-if="invoicetype == 2">企业发票抬头：{{invoice2Name}}</li>
          <li v-if="invoicetype == 2">纳税人识别号：{{invoice2Number}}</li>
          <li v-if="invoicetype == 2">企业发票地址：{{invoice2Address}}</li>
          <li v-if="invoicetype == 2">企业发票电话：{{invoice2Phone}}</li>
          <li v-if="invoicetype == 2">企业发票开户行：{{invoice2Bankname}}</li>
          <li v-if="invoicetype == 2">企业发票开户行账号：{{invoice2Banknumber}}</li>
        </div>
      </el-card>

      <!-- strat -->
      <el-tab-pane label="清单" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Makeinvoiceurl" label="发票网址" min-width="60%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second">
        <el-form :model="addData" ref="addDataRef" label-width="120px">
          <el-form-item label="发票网址" class="addAdminForm">
            <el-input v-model="addData.makeinvoiceurl" placeholder="请输入发票网址"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="three">
        <el-form :model="editData" ref="editDataRef" label-width="120px">
          <el-form-item label="发票网址" class="addAdminForm">
            <el-input v-model="editData.makeinvoiceurl" placeholder="请输入发票网址"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      orderid: '',
      addData: {
        makeinvoiceurl: ''
      },
      editData: {
        id: '',
        makeinvoiceurl: ''
      },
      invoicetype: 0,
      invoice1Name: '',
      invoice2Name: '',
      invoice2Number: '',
      invoice2Address: '',
      invoice2Phone: '',
      invoice2Bankname: '',
      invoice2Banknumber: ''
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.orderid = row.Orderid
      this.invoicetype = row.Invoicetype
      this.invoice1Name = row.Invoice1Name
      this.invoice2Name = row.Invoice2Name
      this.invoice2Number = row.Invoice2Number
      this.invoice2Address = row.Invoice2Address
      this.invoice2Phone = row.Invoice2Phone
      this.invoice2Bankname = row.Invoice2Bankname
      this.invoice2Banknumber = row.Invoice2Banknumber
      this.GetKgjtWebsiteOfflineOrderInvoiceNum()
      this.GetKgjtWebsiteOfflineOrderInvoiceList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteOfflineOrderInvoiceList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.AddKgjtWebsiteOfflineOrderInvoice()
    },
    clickEdit (row) {
      this.editData.id = row.Id
      this.editData.makeinvoiceurl = row.Makeinvoiceurl
      this.activeName = 'three'
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteOfflineOrderInvoice(row)
      })
    },
    clickModify () {
      this.EditKgjtWebsiteOfflineOrderInvoice()
    },
    GetKgjtWebsiteOfflineOrderInvoiceList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteOfflineOrderInvoiceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteOfflineOrderInvoiceNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteOfflineOrderInvoiceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteOfflineOrderInvoice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.orderid,
        makeinvoiceurl: that.addData.makeinvoiceurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteOfflineOrderInvoice, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteOfflineOrderInvoiceNum()
            that.GetKgjtWebsiteOfflineOrderInvoiceList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteOfflineOrderInvoice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        makeinvoiceurl: that.editData.makeinvoiceurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteOfflineOrderInvoice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteOfflineOrderInvoiceList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteOfflineOrderInvoice: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteOfflineOrderInvoice, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteOfflineOrderInvoiceNum()
          that.GetKgjtWebsiteOfflineOrderInvoiceList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
